import React from "react"
import { Box, Collapse } from "@material-ui/core"
import { makeStyles } from "@material-ui/styles"
import { Blockquote } from "."
import { Icon, LinkButton } from ".."

const useStyles = makeStyles(() => ({
  button: {
    fontWeight: "normal",
    margin: 0,
    padding: 0,
    lineHeight: "inherit",
    verticalAlign: "inherit",
  },
}))

const DraftBlockquote = ({ show = false, subject, onDiscard }) => {
  const classes = useStyles()

  const handleDiscard = () => {
    onDiscard && onDiscard()
  }

  return (
    <Collapse in={show}>
      <Box mb={3}>
        <Blockquote
          icon={<Icon name="draft" />}
          title={`${subject} restored from draft`}
          body={
            <>
              This article was restored from an unsaved draft, to start fresh{" "}
              <LinkButton onClick={handleDiscard} className={classes.button}>
                discard the draft
              </LinkButton>
            </>
          }
          color="primary"
        />
      </Box>
    </Collapse>
  )
}

export { DraftBlockquote }
